import QuestionValue from "./QuestionValue";

export default class QuestionValueFraction extends QuestionValue {
    constructor(numerator, denominator) {
        super(numerator / denominator);

        this._numerator = numerator;
        this._denominator = denominator;
    }

    toString() {
        return this._numerator + "/" + this._denominator;
    }

    get numerator() {
        return this._numerator;
    }

    get denominator() {
        return this._denominator;
    }
}